module.exports = __webpack_public_path__ + "0b4679b1c48f7443e7600fe4207556ac.jpg";